import './index.css';
import './styles/Common.less';
import './styles/Components.less';
import '@/utilities/helpers/calendarHelper';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import AppRoutes from './Components/Routes';
import { Provider } from 'react-redux';
import { store } from '@vantiva-sa/homesight_humaui/Store/Store';
import { ConfigProvider } from 'antd';
import { ThemeProvider } from 'styled-components';
import {
  GlobalStyles,
  LoggerProvider,
  MeetingProvider,
  lightTheme,
} from 'amazon-chime-sdk-component-library-react';
import { ConsoleLogger, LogLevel } from 'amazon-chime-sdk-js';
import { BrowserRouter } from 'react-router-dom';
import { MainProvider } from './MainContext';
import { GalleryUploadProvider } from './Components/Gallery/GalleryUploadContext';

const logger = new ConsoleLogger('ChimeMeetingLogs', LogLevel.WARN);

const root = ReactDOM.createRoot(document.getElementById('root'));

const cachingTime = 60_000;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: cachingTime, // 60s fresh
      gcTime: cachingTime,
      refetchOnWindowFocus: false,
      refetchOnMount: true, // important to prevent fetch on refresh
    },
  },
});

const renderApp = () => {
  root.render(
    <QueryClientProvider client={queryClient}>
      <LoggerProvider logger={logger}>
        <ThemeProvider theme={lightTheme}>
          <GlobalStyles />
          <MeetingProvider>
            <ConfigProvider
              theme={{
                token: {
                  fontFamily: 'Euclid Circular',
                },
              }}
            >
              <Provider store={store}>
                <BrowserRouter>
                  <MainProvider>
                    <GalleryUploadProvider>
                      <AppRoutes />
                    </GalleryUploadProvider>
                  </MainProvider>
                </BrowserRouter>
              </Provider>
            </ConfigProvider>
          </MeetingProvider>
        </ThemeProvider>
      </LoggerProvider>
    </QueryClientProvider>
  );
};

renderApp();

if (module.hot) {
  module.hot.accept('@/Components/Routes', () => {
    renderApp();
  });
}
